import { Box, Container, styled, Typography } from '@mui/material';
import { ReactElement } from 'react';

import { DeprecatedBaseHeaderProps } from '@localstack/types';

import { PlanChip } from '../../feedback/PlanChip';
import { SidebarIcon } from '../../display';

const HeaderWrapper = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(2.5),
  paddingBottom: theme.spacing(2.5),
  borderColor: `${theme.palette.divider} !important`,
  borderBottom: '1px solid',
  backgroundColor: theme.palette.background.default,
}));

const Actions = styled('div')(({ theme }) => ({
  flexGrow: 1,
  display: 'flex',
  zIndex: 1,
  alignItems: 'center',
  gap: theme.spacing(1),
  justifyContent: 'right',
}));

const HeaderTabs = styled('div')(({ theme }) => ({
  borderBottom: '1px solid',
  color: theme.palette.divider,
  borderColor: theme.palette.divider,
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));

export const DeprecatedBaseHeader = ({
  title,
  planFamily,
  actions,
  children,
  maxWidth,
  fullScreen,
  tabs,
}: DeprecatedBaseHeaderProps): ReactElement => {
  const containerMaxWidth = fullScreen ? false : maxWidth;

  return (
    <>
      {
        <HeaderWrapper data-name="in-page navigation and actions">
          <Container maxWidth={containerMaxWidth}>
            <Box display="flex" justifyContent="space-between" alignItems="center" justifyItems="right">
              <Box display="flex" alignItems="center" gap={1} minWidth={0}>
                <SidebarIcon />
                {typeof title === 'string' ? (
                  <>
                    <Typography variant="h4">{title}</Typography>
                    {planFamily && <PlanChip planFamily={planFamily} showTooltip />}
                  </>
                ) : (
                  title
                )}
              </Box>
              <Actions>{actions}</Actions>
            </Box>
          </Container>
        </HeaderWrapper>
      }
      {tabs && (
        <HeaderTabs id="tabs">
          <Container
            maxWidth={containerMaxWidth}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            {tabs}
          </Container>
        </HeaderTabs>
      )}
      {children}
    </>
  );
};
